<template>
  <BaseDrawer v-model:visible="isProfileNavVisible" @hide="hideDrawer">
    <template #header>
      <div class="drawer__header" />
    </template>
    <ul class="drawer__body">
      <li v-for="navChild in profileNavItem.children" :key="navChild.class" class="drawer__content">
        <!-- Switch dashboard -->
        <button
          v-if="navChild.label === 'Switch Dashboard'"
          :id="navChild.class"
          class="drawer__profile-content"
          :class="navChild.class"
          @click="startSwitchOrganization"
        >
          <!-- prettier-ignore -->
          <KIcon :icon="(navChild.icon as string)" size="lg" class="drawer__profile-icon" />
          {{ navChild.label }}
        </button>

        <!-- Nav buttons -->
        <button
          v-else
          :id="navChild.class"
          class="drawer__profile-content"
          :class="navChild.class"
          @click="(event) => navigate(navChild.command, event)"
        >
          <!-- prettier-ignore -->
          <KIcon :icon="(navChild.icon as string)" size="lg" class="drawer__profile-icon" />
          {{ navChild.label }}
        </button>
      </li>
    </ul>
  </BaseDrawer>
</template>

<script setup lang="ts">
import { KIcon } from "@k2united/frontend_components";
import BaseDrawer from "@/components/base/BaseDrawer.vue";
import { useUserStore } from "@/stores/user";
import { computed, ref } from "vue";

const emit = defineEmits(["startSwitchOrganization"]);

const store = useUserStore();

// Nav Buttons
const profileNavItem = computed(() => {
  if (store.isInternalAdmin) {
    return store.getInternalProfileNavInfo;
  }
  return store.getProfileNavInfo;
});

// Mobile Drawer
const isProfileNavVisible = ref(false);

const showDrawer = () => {
  isProfileNavVisible.value = true;
};

const hideDrawer = () => {
  isProfileNavVisible.value = false;
};

const startSwitchOrganization = () => {
  emit("startSwitchOrganization");
  hideDrawer();
};

const navigate = (command: ((event: any) => void) | undefined, event: MouseEvent) => {
  if (command) {
    command(event);
  }
  hideDrawer();
};

defineExpose({
  hideDrawer,
  showDrawer
});
</script>

<style scoped lang="scss">
.drawer__content {
  padding: 0 1rem;

  &:hover,
  &:focus {
    background-color: $color-industry-blue-highlight;
  }

  &:has(.sub-menu__border) {
    border-top: solid 1px $color-border-subtle;
  }
}

.drawer__body {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0.5rem 1rem;
}

.drawer__sub-menu-content {
  background: linear-gradient($color-border-subtler, $color-border-subtler) bottom right no-repeat;
  background-size: 95% 1px;
  border-bottom: none;
  padding: 1rem 1rem;
  text-align: left;
  width: 100%;
}

.drawer__profile-content {
  color: $color-text-default;
  font-weight: 400;
  padding: 1rem 0;
  text-align: left;
  width: 100%;
}

.drawer__profile-icon {
  padding-right: 0.2rem;
}
</style>
